export type ViewName =
  | "login"
  | "signupTerms"
  | "signupProfile"
  | "signupEmail"
  | "signupDone"
  | "findId"
  | "findPassword"
  | "resetPassword"
  | "home"
  | "productHome"
  | "productSearch"
  | "shop"
  | "productDetail"
  | "notices"
  | "noticeDetail"
  | "packaging"
  | "packagingForm"
  | "upload"
  | "uploadLoading"
  | "recommendation"
  | "quoteRequest"
  | "quotes"
  | "quoteDetail"
  | "quoteOfferDetail"
  | "payment"
  | "paymentSuccess"
  | "paymentFail"
  | "paymentHistory"
  | "paymentDetail"
  | "my"
  | "profile"
  | "inquiries"
  | "inquiryWrite"
  | "inquiryDetail";

export function currentView(): ViewName {
  return (new URL(window.location.href).searchParams.get("view") ||
    "login") as ViewName;
}

export function navigate(view: ViewName, params: Record<string, string> = {}) {
  const url = new URL(window.location.href);
  url.searchParams.set("view", view);
  Object.entries(params).forEach(([key, value]) =>
    url.searchParams.set(key, value),
  );
  window.history.pushState({ view }, "", url);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}

export function goBack(fallback: ViewName = "home") {
  if (window.history.state?.view) window.history.back();
  else navigate(fallback);
}

export function goToFallback(fallback: ViewName = "home") {
  navigate(fallback);
}
